export const IGNORE = {
  ROUTES: ["/loader", "/errors/404", "/errors/400"],
};
